<kodit-card-container>
  <div card-title>Dokumentacija</div>

  <div card-right-side>
    <button
      icon="far fa-edit"
      pButton
      type="button"
      label="Izmeni"
      class="p-button p-button-outlined"
      (click)="onEdit()"
    ></button>
  </div>
  <div class="p-d-flex" card-body *ngIf="podesavanjaArhivskeDokumentacijeDto">
    <div class="p-flex-1 p-d-flex p-flex-column gap-2">
        <button
          pRipple
          pButton
          [disabled]="disableButton"
          icon="fas fa-download"
          iconPos="left"
          type="button"
          label="Preuzmi dopis za listu kategorija"
          class="p-button-text"
          style="width: 100%; text-align: left;"
          (click)="preuzmiDopis(dopisVrsta.DOPIS_LISTA)"
        ></button>
        <button
          pRipple
          pButton
          [disabled]="disableButton"
          icon="fas fa-download"
          iconPos="left"
          type="button"
          label="Preuzmi dopis za arhivsku knjigu"
          class="p-button-text"
          style="width: 100%; text-align: left;"
          (click)="preuzmiDopis(dopisVrsta.DOPIS_ARHIVSKA)"
        ></button>
        <button
          pRipple
          pButton
          [disabled]="disableButton"
          icon="fas fa-download"
          iconPos="left"
          type="button"
          label="Preuzmi dopis za listu kategorija i arhivsku knjigu"
          class="p-button-text"
          style="width: 100%; text-align: left;"
          (click)="preuzmiDopis(dopisVrsta.LISTA_I_ARHIVSKA)"
        ></button>
      </div>

       <div class="p-flex-1 p-d-flex p-ai-start p-jc-end">
          <button
            pRipple
            pButton
            icon="fas fa-download"
            iconPos="left"
            type="button"
            label="Dokumentacija"
            class="p-button-text"
            style="width: 100%; text-align: left;"
            (click)="preuzmiDokumentaciju()"
          ></button>
      </div>

  </div>

</kodit-card-container>
